import store from '@/store'
import axios from 'axios'
import { Message } from 'element-ui'
import util from '@/libs/util'
import { isPlainObject } from 'lodash'

// 创建一个错误
function errorCreate(msg) {
  const sendMsg = isJsonStr(msg);
  const error = new Error(sendMsg)
  errorLog(error)
  throw error
}
//判断是否为josn字符串
function isJsonStr(str) {
  if (typeof str == 'string') {
    try {
      var obj = JSON.parse(str);
      if (typeof obj == 'object' && obj) {
        var sendMsg = ""
        for (const i in obj) {
          sendMsg += obj[i] + ","
        }
        return sendMsg;
      } else {
        return str;
      }
    } catch (e) {
      return str;
    }
  }

}
// 记录和显示错误
function errorLog(error) {
  // 添加到日志
  // store.dispatch('d2admin/log/push', {
  //   message: '数据请求异常',
  //   type: 'danger',
  //   meta: {
  //     error
  //   }
  // })
  // 打印到控制台
  if (process.env.NODE_ENV === 'development') {
    util.log.danger('>>>>>> Error >>>>>>')
    console.log(error)
  }
  // 显示提示
  Message({
    message: error.message,
    type: 'error',
    duration: 3 * 1000
  })
}

// 创建一个 axios 实例
const service = axios.create({
  baseURL: `${IPConfig.IP}/communication`,
  timeout: 20000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(config => {
  // 在请求发送之前做一些处理
  const token = util.cookies.get('token')
  // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
  config.headers['token'] = token
  // 默认参数
  var defaults = {}
  // 防止缓存，GET请求默认带_t参数
  if (config.method === 'get') {
    config.params = {
      ...config.params,
      ...{ '_t': new Date().getTime() }
    }
  }
  if (isPlainObject(config.params)) {
    config.params = {
      ...defaults,
      ...config.params
    }
  }
  if (isPlainObject(config.data)) {
    config.data = {
      ...defaults,
      ...config.data
    }
    if (/^application\/x-www-form-urlencoded/.test(config.headers['content-type'])) {
      config.data = qs.stringify(config.data)
    }
  }
  return config
},
  error => {
    // 发送失败
    console.log(error)
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    downLoadData = response.data;
    if (response.headers.check == "streamingFile") {
      return response
    }
    // dataAxios 是 axios 返回数据中的 data

    const dataAxios = response.data
    // console.log(dataAxios)
    // 这个状态码是和后端约定的
    var errorCode = dataAxios.status

    // console.log(errorCode)
    // 根据 errorCode 进行判断
    if (errorCode != undefined) {
      if (errorCode === 'success') {
        // 如果没有 errorCode 代表这不是项目后端开发的接口      
        return dataAxios
      } if (errorCode === 'fail' && dataAxios.data.errorCode == "403") {
        //登录过期重新跳转到集约化登录界面
        window.location.href = dataAxios.data.casLoginUrl;
      } else {
        // 有 errorCode 代表这是一个后端接口 可以进行进一步的判断
        // var errorMsg =`[ errorCode: 20002 ] ${dataAxios.data.errorMsg}: ${response.config.url}`;
        var errorMsg = `${dataAxios.data.errorMsg}`;
        errorCreate(errorMsg);
        /* switch (dataAxios.data.errorCode) {
            case 20002:
              errorCreate(`[ errorCode: 20002 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
    
            case 10040:
              errorCreate(`[ errorCode: 10040 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10041:
              errorCreate(`[ errorCode: 10041 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10042:
              errorCreate(`[ errorCode: 10042 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10043:
              errorCreate(`[ errorCode: 10043 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10045:
              errorCreate(`[ errorCode: 10045 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10046:
              errorCreate(`[ errorCode: 10046 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10047:
              errorCreate(`[ errorCode: 10047 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10048:
              errorCreate(`[ errorCode: 10048 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10049:
              errorCreate(`[ errorCode: 10049 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10050:
              errorCreate(`[ errorCode: 10050 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10051:
              errorCreate(`[ errorCode: 10051 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10052:
              errorCreate(`[ errorCode: 10052 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 20001:
              errorCreate(`[ errorCode: 20001 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
    
            case 44002:
              errorCreate(`[ errorCode: 44002 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 44003:
              errorCreate(`[ errorCode: 44003 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 44004:
              errorCreate(`[ errorCode: 44004 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 44005:
              errorCreate(`[ errorCode: 44005 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 44006:
              errorCreate(`[ errorCode: 44006 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 44007:
              errorCreate(`[ errorCode: 44007 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 44008:
              errorCreate(`[ errorCode: 44008 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 20003:
              errorCreate(`[ errorCode: 20003 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 20004:
              errorCreate(`[ errorCode: 20004 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 20006:
              errorCreate(`[ errorCode: 20006 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 20007:
              errorCreate(`[ errorCode: 20007 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 20008:
              errorCreate(`[ errorCode: 20008 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 20009:
              errorCreate(`[ errorCode: 20009 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 200011:
              errorCreate(`[ errorCode: 200011 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 200012:
              errorCreate(`[ errorCode: 200012 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 200013:
              errorCreate(`[ errorCode: 200013 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 200014:
              errorCreate(`[ errorCode: 200014 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 200015:
              errorCreate(`[ errorCode: 200015 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 200016:
              errorCreate(`[ errorCode: 200016 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
    
            case 200017:
              errorCreate(`[ errorCode: 200017 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 200018:
              errorCreate(`[ errorCode: 200018 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 200019:
              errorCreate(`[ errorCode: 200019 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 200020:
              errorCreate(`[ errorCode: 200020 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 99999:
              errorCreate(`[ errorCode: 99999 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break  
            case 10001:
              errorCreate(`[ errorCode: 10001 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10002:
              errorCreate(`[ errorCode: 10002 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10003:
              errorCreate(`[ errorCode: 10003 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10004:
              errorCreate(`[ errorCode: 10004 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10005:
              errorCreate(`[ errorCode: 10005 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10006:
              errorCreate(`[ errorCode: 10006 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10007:
              errorCreate(`[ errorCode: 10007 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10008:
              errorCreate(`[ errorCode: 10008 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 10009:
              errorCreate(`[ errorCode: 10009 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 11001:
              errorCreate(`[ errorCode: 11001 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 12001:
              errorCreate(`[ errorCode: 12001 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 12002:
              errorCreate(`[ errorCode: 12002 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 12003:
              errorCreate(`[ errorCode: 12003 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 12004:
              errorCreate(`[ errorCode: 12004 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 12005:
              errorCreate(`[ errorCode: 12005 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
    
            case 12006:
              errorCreate(`[ errorCode: 12006 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 12007:
              errorCreate(`[ errorCode: 12007 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 12008:
              errorCreate(`[ errorCode: 12008 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 12009:
              errorCreate(`[ errorCode: 12009 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 12010:
              errorCreate(`[ errorCode: 12010 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 12011:
              errorCreate(`[ errorCode: 12011 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 99999:
              errorCreate(`[ errorCode: 99999 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 1990:
              errorCreate(`[ errorCode: 1990 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 1991:
              errorCreate(`[ errorCode: 1991 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 1992:
              errorCreate(`[ errorCode: 1992 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 1993:
              errorCreate(`[ errorCode: 1993 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
            case 1994:
              errorCreate(`[ errorCode: 1994 ] ${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
    
            default:
              // 不是正确的 errorCode
              errorCreate(`${dataAxios.data.errorMsg}: ${response.config.url}`)
              break
          }*/
      }
    }
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400: error.message = '请求错误'; break
        case 401: error.message = '未授权，请登录'; break
        case 403: error.message = '拒绝访问'; break
        case 404: error.message = `请求地址出错: ${error.response.config.url}`; break
        case 408: error.message = '请求超时'; break
        case 500: error.message = '服务器内部错误'; break
        case 501: error.message = '服务未实现'; break
        case 502: error.message = '网关错误'; break
        case 503: error.message = '服务不可用'; break
        case 504: error.message = '网关超时'; break
        case 505: error.message = 'HTTP版本不受支持'; break
        default: break
      }
    }
    errorLog(error)
    return Promise.reject(error)
  }
)

export default service
